
class FiltersNav extends HTMLElement {
    static selectors = {
      dropdown: '[data-bs-toggle="dropdown"]',
      collection: 'main-collection'
    }
    static shownClass = 'filters-open';
    dropdown;
  
    constructor(){
      super();
      this.init();
    } 
  
    init = () => {
        this.dropdown = this.querySelector(FiltersNav.selectors.dropdown);
        this.collection = document.querySelector(FiltersNav.selectors.collection);
        this.dropdown.addEventListener('shown.bs.dropdown', (e) => {
            this.setOpen();
        });
        this.dropdown.addEventListener('hidden.bs.dropdown', (e) => {
            this.setClosed();
        });
    }

    setOpen = () => {
        document.querySelector("html").classList.add(FiltersNav.shownClass);
        if(this.collection != null && this.collection != undefined){
            const position = document.body.scrollTop || document.documentElement.scrollTop;
            const height = this.collection.offsetHeight / 3;
            if(position < height)
                window.scrollTo(0, height); 
        }
    }

    setClosed = () => {
        document.querySelector("html").classList.remove(FiltersNav.shownClass);
    }
     
  }
  if (!window.customElements.get("filters-nav")) {
    window.customElements.define("filters-nav", FiltersNav);
  }